import React from 'react'
import { startTypes } from '../../cnr/reducers/StartReducer'
import MotionWait from '../../motions/MotionWait'

const SuspenseDimmer = (props) => <MotionWait startType={startTypes.suspense} origin={props?.origin || 'SuspenseDimmer'} />

export default SuspenseDimmer